var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vlt-tabs"},[_c('ul',{staticClass:"Vlt-tabs__header",class:{
        'Vlt-tabs__header--bordered': _vm.bordered,
        'Vlt-tabs__header--shadow': _vm.shadow
      }},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,staticClass:"Vlt-tabs__link",class:{
        'Vlt-tabs__link_active' : index === _vm.activeTab,
        'Vlt-tabs__link_disabled': tab.disabled
      },on:{"click":function($event){return _vm.selectTab(index)}}},[(tab.iconName && !_vm.hasIcons)?_c('vlt-icon',{attrs:{"icon":tab.iconName,"no-class":""}}):_vm._e(),(_vm.hasIcons)?_c('vlt-tooltip',{attrs:{"title":tab.label}},[_c('vlt-icon',{attrs:{"icon":tab.iconName,"no-class":""}})],1):_c('span',[_vm._v(_vm._s(tab.label))])],1)}),0),_c('div',{staticClass:"Vlt-tabs__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }